import React from "react";

import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Switch from "@material-ui/core/Switch";

const styles = {
  listItemIcon: {
    maxWidth: 56,
    marginLeft: -16,
    marginRight: 16,
  },
};

const ListItemSwitch = React.forwardRef(
  ({ text, checked, onChange, classes, ...switchProps }, ref) => (
    <ListItem className={classes.listItem} ref={ref}>
      <ListItemIcon className={classes.listItemIcon}>
        <Switch checked={checked} onChange={onChange} {...switchProps} />
      </ListItemIcon>
      <ListItemText>{text}</ListItemText>
    </ListItem>
  )
);

export default withStyles(styles)(ListItemSwitch);
